<template>
    <div class="upgrade-tips">
        <img class="upgrade-img">
        <p>New Version Found</p>

        <div class="btn-container">
            <div class="next-time" @click="nextTime">No, next time</div>
            <div class="upgrade" @click="upgradeDevice">Upgrade</div>
        </div>

    </div>
</template>

<script>
    import bluetoothRepository from "../repository/bluetooth/BluetoothRepository"
    export default {
        name   : "UpgradeTipsDialog",
        props  : {
            otaInfo: {
                type   : Object,
                default: () => {
                    return {}
                }
            }
        },
        methods: {
            upgradeDevice() {
                bluetoothRepository.otaDevice(this.otaInfo)
            },
            nextTime() {
                this.$emit("onCloseDialog")
            }
            //     bluetoothRepository.otaDevice(otaInfo)
        }
    }
</script>

<style lang="scss" scoped>
    .upgrade-tips {
        display: flex;
        align-items: center;
        flex-direction: column;
        color: #F6F6F6;
        width: 256px;
        background-color: #333333;

        .upgrade-img {
            width: 120px;
            margin-top: 16px;
            height: 130px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            @include bg-image("../assets/UpgradeTips");
        }

        .btn-container {
            width: 100%;
            display: flex;
            flex-direction: row;

            .next-time {
                flex: 1;
                font-size: 13px;
                padding: 10px;
                text-align: center;
                background-color: #222222;
                color: #999999;
            }

            .upgrade {
                flex: 1;
                padding: 10px;
                font-size: 13px;
                text-align: center;
                background-color: #F6F6F6;
                color: #000000;
            }
        }
    }

</style>